import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, Table, TableBody, TableCell, TableRow, TableHead, Dialog} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import GetRole from "./user";
import { fetchProjects, fetchProjectbyId, addProject, updateProjectdata, fetchProjectbyDept} from "../api/customerapi";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField4: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(80),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
     textField5: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(160),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(10),
        height: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Project = () => {

    const classes = useStyles();
    const { cuser, role, employeelist, destinationlist, loading } = GetRole();
    const [projectData, setprojectData] =useState({
        name: "",
        department:"",
    });
    const [open, setopen]=useState(false);
    const [currentproj, setcurrentproj]=useState(false);
    const [filterData, setfilterData]=useState(false);
    const [projlist, setprojlist]=useState([]);
    
   
    const getProjectbyId = async (currentid) => {
        try{
          var p=projlist.filter(p=>p.project_id==currentid)
          console.log(p, currentid)
          setcurrentproj(p[0])
          setopen(true)
    }catch(err){
        console.log(err)
      }
    }

    const createProject = async () => {
        try{
          const data=await addProject(projectData)
           if(data.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
           alert("New project added with project id "+data.data.project_id);
            window.location.reload()
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
      
    }catch(err){
        console.log(err)
      }
    }

    const getProjects = async () => {
        try{
        const data = await fetchProjects();
        var temp=data.data.filter(p=>p.status=="Open" && (p.owner==cuser || p.owner=="" || !("owner" in p)))
        var temp2=temp.sort(function(a, b) {
    var textA = a.department.toUpperCase();
    var textB = b.department.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
        setprojlist(temp2)
    }catch(err){
        console.log(err)
      }
    }
    var templist=[...projlist]

         const handleClose = () => {
    setopen(false);
  };

     useEffect(() => {
      if(!loading){
        getProjects()  
      }
        
    }, [cuser, role, employeelist, destinationlist, loading])

   

  // console.log(currentproj)
    const updateProj =async () => {
        try{
     
       
        const updateprojResponse= await updateProjectdata(currentproj._id, currentproj);
        
        if(updateprojResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for project with project id "+updateprojResponse.data.project_id);
            setopen(false)
            window.location.reload()
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }  
    }catch(err){
        console.log(err)
      }     
    }

    if(filterData && filterData.department){
      templist=projlist.filter(p=>p.department==filterData.department)
      
    }

    return (
        <Paper variant="outlined" className={classes.paper} elevation={10}>
          <Typography variant="h4" align="center" className={classes.headertext}>Project List</Typography>
      <FormGroup row className={classes.formgroup}>
          <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                    <InputLabel id="Department">Department</InputLabel>
                        <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Department" value={filterData.department} onChange={(e)=> setfilterData({...filterData, department: e.target.value})}>
                         <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Sales"}>Sales</MenuItem>
                        <MenuItem value={"Operations"}>Operations</MenuItem>
                        <MenuItem value={"CX"}>CX</MenuItem>
                        <MenuItem value={"Marketing"}>Marketing</MenuItem>
                        <MenuItem value={"Product"}>Product</MenuItem>
                        <MenuItem value={"Accounts"}>Accounts</MenuItem>
                        <MenuItem value={"Sales Support"}>Sales Support</MenuItem>
                        <MenuItem value={"HR"}>HR</MenuItem>
                        <MenuItem value={"Admin"}>Admin</MenuItem>
                        <MenuItem value={"Strategy"}>Strategy</MenuItem>    
                        <MenuItem value={"Others"}>Others</MenuItem>    
                        
                        </Select>
                        </FormControl>
       </FormGroup>
        <Table size="small">
          <TableHead>
            <TableRow>
            <TableCell width={100}>
                Id
              </TableCell>
              <TableCell width={600}>
                Name
              </TableCell>
              <TableCell width={100}>
                Owner
              </TableCell>
              <TableCell width={100}>
                Department
              </TableCell>
              <TableCell width={100}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templist.length>0 && templist.map(p=>{return(<TableRow>
            <TableCell sx={{ height: 22 }} width={100}>{p.project_id}</TableCell>
              <TableCell sx={{ height: 22 }} width={600}>{p.name}</TableCell>
              <TableCell sx={{ height: 22 }} width={600}>{p.owner}</TableCell>
              <TableCell sx={{ height: 22 }} width={100}>{p.department}</TableCell>
              <TableCell sx={{ height: 22 }} width={100}><Button onClick={()=>getProjectbyId(p.project_id)} variant="contained" color="secondary" className={classes.button}>Update</Button></TableCell>
            </TableRow>)})}
          </TableBody>
        </Table>
    
              <br></br>
              <br></br>
              <br></br>
              <hr></hr>
              <br></br>
              <br></br>
              <br></br>
       <Typography variant="h4" align="center" className={classes.headertext}>Add Project</Typography>
            
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  required label="Name"  value={projectData.name} className={classes.textField4} onChange={(e)=> setprojectData({...projectData, name: e.target.value})}/>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                    <InputLabel id="Department">Department</InputLabel>
                        <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Department" value={projectData.department} onChange={(e)=> setprojectData({...projectData, department: e.target.value})}>
                        <MenuItem value={"Sales"}>Sales</MenuItem>
                        <MenuItem value={"Operations"}>Operations</MenuItem>
                        <MenuItem value={"CX"}>CX</MenuItem>
                        <MenuItem value={"Marketing"}>Marketing</MenuItem>
                        <MenuItem value={"Product"}>Product</MenuItem>
                        <MenuItem value={"Accounts"}>Accounts</MenuItem>
                        <MenuItem value={"Sales Support"}>Sales Support</MenuItem>
                        <MenuItem value={"HR"}>HR</MenuItem>
                        <MenuItem value={"Admin"}>Admin</MenuItem>
                        <MenuItem value={"Strategy"}>Strategy</MenuItem>    
                        <MenuItem value={"Others"}>Others</MenuItem>    
                        
                        </Select>
                        </FormControl>
               <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                    <InputLabel id="Department">Status</InputLabel>
                        <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Status" value={projectData.status} onChange={(e)=> setprojectData({...projectData, status: e.target.value})}>
                        <MenuItem value={"Open"}>Open</MenuItem>
                        <MenuItem value={"Closed"}>Closed</MenuItem>
                          
                        
                        </Select>
                        </FormControl>     
                        <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                    <InputLabel id="Owner">Owner</InputLabel>
                        <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Status" value={projectData.owner} onChange={(e)=> setprojectData({...projectData, owner: e.target.value})}>
                        <MenuItem value={"Amit"}>Amit</MenuItem>
                        <MenuItem value={"Debayan"}>Debayan</MenuItem>
                          
                        
                        </Select>
                        </FormControl>         
        </FormGroup>        

          <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" onClick={createProject} className={classes.button}>Save</Button>
             <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
           </FormGroup>
          <Dialog fullWidth
        maxWidth="xl"
        open={open}
        onClose={handleClose}>
        <Typography variant="h4" align="center" className={classes.headertext}>{currentproj.name}</Typography>
        <Typography variant="h4" align="center" className={classes.headertext}>{currentproj.department}</Typography>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                    <InputLabel id="Department">Status</InputLabel>
                        <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Status" value={currentproj.status} onChange={(e)=> setcurrentproj({...currentproj, status: e.target.value})}>
                        <MenuItem value={"Open"}>Open</MenuItem>
                        <MenuItem value={"Closed"}>Closed</MenuItem>
                          
                        
                        </Select>
                        </FormControl>
        {currentproj && currentproj.update.length>0 && currentproj.update.map(u=><div>
          <TextField
            variant="standard"
            label="Date"
            disabled={currentproj.update.indexOf(u)==currentproj.update.length-1?0:1}
            type="Date"
            value={"date" in u && u.date?u.date.split("T").slice(0,1):""}
            className={classes.textField}
            onChange={(e)=>setcurrentproj({...currentproj, update:currentproj.update.map(u=>currentproj.update.indexOf(u)==currentproj.update.length-1?{...u, date:e.target.value}:u)})}
          />
            <TextField
            variant="standard"
            label="Note"
            multiline 
            disabled={currentproj.update.indexOf(u)==currentproj.update.length-1?0:1}
            onChange={(e)=>setcurrentproj({...currentproj, update:currentproj.update.map(u=>currentproj.update.indexOf(u)==currentproj.update.length-1?{...u, note:e.target.value}:u)})}
            value={u.note}
            className={classes.textField5}
          />
        </div>)}
         <FormGroup row className={classes.formgroup}>
                    <Button
                      variant="outlined"
                      color="primary"
                      className={classes.button}
                      onClick={()=>setcurrentproj({...currentproj, update:[...currentproj.update,{date:"", note:""}]})}
                      
                    >
                      {" "}
                      + Tranche
                    </Button>
                    <Button
                      variant="outlined"
                      color="secondary"
                      className={classes.button}
                      onClick={()=>setcurrentproj({...currentproj, update:[...currentproj.update].slice(0, currentproj.update.length - 1)})}
                    >
                      {" "}
                      - Tranche
                    </Button>
                      <Button
                      variant="contained"
                      color="primary"
                      onClick={updateProj}
                      className={classes.button}
                    >
                      Save
                    </Button>
                  </FormGroup>
          
              
          </Dialog>
        
        </Paper>
     );
}

export default Project;